import { Grid, Typography } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import LinearProgress from "@material-ui/core/LinearProgress";
import Link from "@material-ui/core/Link";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import axios from "axios";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import firebase from "../../firebase/firebase";
import Button from "../commons/Button";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  inputs: {
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
  linearProgess: {
    width: "100%",
    margin: theme.spacing(1),
  },
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
  },
}));

const TicketModal = ({ modalIsopen, setModalOpen, template }) => {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalText, setModalText] = useState("");
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  useEffect(() => {
    setModalText("");
  }, [modalIsopen]);

  const renderModal = () => {
    if (!template.eventName) {
      return (
        <Typography>
          No Event Selected. Please save your event before generating a QR code.
        </Typography>
      );
    }

    return (
      <>
        <Typography variant="h5" id="simple-modal-title">
          Generate QR code for {template.eventName}
        </Typography>
        <TextField
          fullWidth
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setModalText("");
          }}
          id="standard-basic"
          label="contact@company.com"
        />
        {loading ? (
          <div className={classes.linearProgess}>
            <LinearProgress />
          </div>
        ) : (
          <>
            <Grid container justify="center" alignItems="center">
            <Checkbox
              checked={checked}
              onChange={handleChange}
              name="checkedB"
              color="primary"
            />
            <Typography>
              I accept the 
              <Link 
                style={{ marginLeft: '5px' }} 
                href="https://www.seek-city.com/copy-of-terms-conditions"
                target="_blank"
              >
                terms & conditions
              </Link>
            </Typography>
            </Grid>
            <Button
              disabled={!checked}
              onClick={async () => {
                try {
                  setLoading(true);
                  const token = await firebase
                    .auth()
                    .currentUser.getIdToken(true);
                  const headers = {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                  };

                  await axios({
                    method: "POST",
                    data: {
                      id: template.id,
                      eventName: "",
                      email,
                    },
                    url: "https://us-central1-seekcity.cloudfunctions.net/generateQRCode",
                    headers,
                  });

                  setModalText(`QR code sent to: ${email}.`);
                  setLoading(false);
                } catch (e) {
                  setModalText("Something went wrong... Please try again.");
                  setLoading(false);
                }
              }}
              title="Generate"
              color="primary"
            />
          </>
        )}
        <Typography>{modalText}</Typography>
      </>
    );
  };

  return (
    <Modal open={modalIsopen} onClose={() => setModalOpen(false)}>
      <Paper className={classes.modal}>{renderModal()}</Paper>
    </Modal>
  );
};

export default TicketModal;

TicketModal.defaultProps = {
  template: {
    eventName: "",
  },
  modalIsopen: false,
};

TicketModal.propTypes = {
  setModalOpen: PropTypes.func.isRequired,
};
